var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LogOut"},[_c('div',{attrs:{"hide":"","hidden":""}},[_vm._v("LOGOUT")]),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }